import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityTaskCategoriesDataProvider } from './dataProvider';

// 注册 activity/taskCategories模块的数据提供者
export function initActivityTaskCategoriesDataProvider() {
  registerModuleDataProvider('activity-task-category', activityTaskCategoriesDataProvider);
}

// 自动初始化
initActivityTaskCategoriesDataProvider();
